<template>
  <div class="">
    <Modal
      title="编辑资料"
      v-model="currValue"
      :loading="loading"
      @on-visible-change="currValue = $event"
      @on-ok="save"
    >
      <div class="">
        <Form
          ref="editAccountForm"
          :label-width="80"
          :model="form"
          :rules="formRules"
        >
          <FormItem label="姓名" prop="name">
            <Input v-model="form.name"></Input>
          </FormItem>
          <FormItem label="手机号" prop="phone">
            <Input v-model="form.phone"></Input>
          </FormItem>
          <FormItem label="账号">
            {{ user.login_name }}
          </FormItem>
          <FormItem label="密码">
            <a href="javascript:void(0)" @click="editPasswowrdModalShow = true">
              修改密码
            </a>
          </FormItem>
        </Form>
      </div>
    </Modal>

    <Modal
      title="修改密码"
      v-model="editPasswowrdModalShow"
      :loading="passwordLoading"
      @on-ok="savePassword"
    >
      <Form
        ref="editPasswordForm"
        :label-width="80"
        :model="passwordForm"
        :rules="passwordFormRules"
      >
        <!-- <FormItem label="原密码" prop="oldPassword">
          <Input v-model="passwordForm.oldPassword" type="password"></Input>
        </FormItem> -->
        <FormItem label="新密码" prop="password">
          <Input v-model="passwordForm.password" type="password"></Input>
        </FormItem>
        <FormItem label="确认密码" prop="agNewPassword">
          <Input v-model="passwordForm.agNewPassword" type="password"></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  props: {
    value: Boolean,
  },
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value !== this.passwordForm.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      currValue: this.value,
      loading: true,
      passwordLoading: true,
      form: {
        name: '',
        phone: '',
      },
      formRules: {
        name: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
        phone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          { min: 6, max: 13, message: '请输入正确的联系电话', trigger: 'blur' },
        ],
      },
      passwordForm: {
        oldPassword: '',
        password: '',
        agNewPassword: '',
      },
      passwordFormRules: {
        oldPassword: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 6, message: '密码不能少于6位', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 6, message: '密码不能少于6位', trigger: 'blur' },
        ],
        agNewPassword: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' },
        ],
      },
      editPasswowrdModalShow: false,
    }
  },
  computed: {
    ...mapState('user', ['user']),
  },
  watch: {
    value(val) {
      this.currValue = val
    },
    currValue(val) {
      this.$emit('input', val)
    },
  },
  methods: {
    ...mapMutations('user', ['_user']),
    save() {
      setTimeout(() => {
        this.loading = false
        setTimeout(() => {
          this.loading = true
        }, 100)
      }, 1000)
      this.$refs['editAccountForm'].validate((valid) => {
        if (valid) {
          let data = {
            ...this.form,
            id: this.user.id,
          }
          this.$http.post('/user/edit', data).then((res) => {
            if (res.success) {
              this.$Message.success('修改成功')
              this.currValue = false
              // 更新vuex
              let user = this.user
              user.name = this.form.name
              user.phone = this.form.phone
              this._user(user)
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    savePassword() {
      setTimeout(() => {
        this.passwordLoading = false
        setTimeout(() => {
          this.passwordLoading = true
        }, 100)
      }, 1000)

      this.$refs['editPasswordForm'].validate((valid) => {
        if (valid) {
          let data = {
            password: this.passwordForm.password,
            id: this.user.id,
          }
          this.$http.post('/user/edit', data).then((res) => {
            if (res.success) {
              this.$Message.success('修改成功')
              this.editPasswowrdModalShow = false
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
  },
  created() {
    this.form.name = this.user.name
    this.form.phone = this.user.phone
  },
}
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/pages/EditAccountModal.vue